import {Component, Input, OnInit} from '@angular/core';
import {localizeUserExamGrade, LocationExamStats, UserExamGrade} from '../../../model/stats/Stats';

@Component({
  selector: 'exam-region-schools-result-table',
  templateUrl: './exam-region-schools-result-table.component.html',
  styleUrls: ['./exam-region-schools-result-table.component.scss']
})
export class ExamRegionSchoolsResultTableComponent implements OnInit {

  readonly examGrades = UserExamGrade;

  readonly mobileColumnsToDisplay = [
    'school-name',
    'excellent-count',
    'good-count',
    'average-count',
    'teachers-count'
  ];
  columnsToDisplay = [
    'school-name',
    'school-address',
    'school-region-name',
    'excellent-count',
    'excellent-count-padded',
    'good-count',
    'good-count-padded',
    'average-count',
    'average-count-padded',
    'participants',
    'participants-padded',
    'teachers-count',
    'teachers-count-padded'
  ];

  @Input() examStats?: LocationExamStats[];

  @Input() mobileView = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  localizeExamGrade(grade: UserExamGrade) {
    return localizeUserExamGrade(grade);
  }

  countTotals(grade: UserExamGrade, padding = 1): number {
    let value = 0;
    switch (grade) {
      case UserExamGrade.excellent:
        value = this.examStats?.map(s => s.excellentResults || 0).reduce((r1, r2) => r1 + r2) || 0;
        break;
      case UserExamGrade.good:
        value = this.examStats?.map(s => s.goodResults || 0).reduce((r1, r2) => r1 + r2) || 0;
        break;
      case UserExamGrade.average:
        value = this.examStats?.map(s => (s.averageResults || 0) + (s.skipped || 0)).reduce((r1, r2) => r1 + r2) || 0;
        break;
    }

    return padding > 1
      ? Math.ceil(value * padding) || 0
      : value;
  }

  countTeachersTotal(padding = 1): number {
    const value = this.examStats?.map(s => s.teachers || 0).reduce((r1, r2) => r1 + r2) || 0;

    return padding > 1
      ? Math.ceil(value * padding) || 0
      : value;
  }

  countParticipantsTotal(padding = 1) {
    const value = this.countTotals(UserExamGrade.excellent) + this.countTotals(UserExamGrade.good) + this.countTotals(UserExamGrade.average);

    return padding > 1
      ? Math.ceil(value * padding) || 0
      : value;
  }

  padValue(value: number, padding: number): number {
    return Math.ceil(value * padding) || 0;
  }
}
